export default __webpack_public_path__ + "static/media/hht1_ep07_timeline_q04_a.9f907b3e.png";